module.exports = __webpack_public_path__ + "img/Ulvis-Priedulis.42e2ae3b.svg";